import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieNotice.module.css';

export const COOKIE_NOTICE_STORAGE_KEY = 'cookieNoticeAcknowledged';

const FALLBACK_COOKIE_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

const hasFallbackCookie = () => (
    document.cookie
        .split(';')
        .some((cookie) => cookie.trim().indexOf(`${COOKIE_NOTICE_STORAGE_KEY}=true`) === 0)
);

export const isCookieNoticeAcknowledged = () => {
    try {
        if (window.localStorage.getItem(COOKIE_NOTICE_STORAGE_KEY) === 'true') {
            return true;
        }
    } catch (error) {
        // localStorage can be unavailable (private mode, blocked storage); fall back to cookie.
    }

    return hasFallbackCookie();
};

const storeAcknowledgement = () => {
    try {
        window.localStorage.setItem(COOKIE_NOTICE_STORAGE_KEY, 'true');
        return;
    } catch (error) {
        // Fall back to a cookie so the notice stays dismissed.
    }

    document.cookie = `${COOKIE_NOTICE_STORAGE_KEY}=true; path=/; max-age=${FALLBACK_COOKIE_MAX_AGE_SECONDS}; SameSite=Strict`;
};

const CookieNotice = () => {
    const [isVisible, setIsVisible] = useState(() => !isCookieNoticeAcknowledged());

    if (!isVisible) {
        return null;
    }

    const handleAcknowledge = () => {
        storeAcknowledgement();
        setIsVisible(false);
    };

    return (
        <div className={styles.notice} role="region" aria-label="Cookie notice">
            <p className={styles.text}>
                We use only essential cookies required for signing in and keeping your session
                secure. No analytics or advertising cookies are used.{' '}
                <Link to="/privacy_policy" className={styles.link}>
                    Learn more
                </Link>
            </p>
            <button
                type="button"
                className={styles.button}
                onClick={handleAcknowledge}
            >
                Got it
            </button>
        </div>
    );
};

export default CookieNotice;
